import FullPage from "./layout/FullPage";

function App() {
  return (
    <>
      <div>
        <FullPage />
      </div>
    </>
  );
}

export default App;
